<template>
  <div class="d-flex flex-column h-100 overflow-hidden bg-grad">
    <b-navbar type="dark" class="justify-content-between my-2" v-if="!$route.meta.home && !$route.meta.menu">
      <div>
        <router-view name="back"/>
      </div>

      <b-navbar-brand tag="div" href="#" class="m-0">{{ t($route.meta.title) }}</b-navbar-brand>

      <div>
        <a href="tel:133" class="text-white" :hidden="$route.meta.hideSOS">
          <i-sos height="1.8em" width="1.8em"></i-sos>
        </a>
      </div>
    </b-navbar>

    <b-navbar type="dark" class="justify-content-center my-5" v-else-if="$route.meta.menu">
      <b-img :src="require('../../assets/img/menu-logo.svg')"></b-img>
    </b-navbar>

    <transition name="fade" mode="out-in">
      <router-view :class="{'pb-6': !$route.meta.sub, 'border-top-radius': !$route.meta.home}"
                   class="flex-grow-1 bg-white shadow overflow-auto h-100"/>
    </transition>

    <b-row class="fixed-bottom" align-h="center" v-if="!$route.meta.sub">
      <b-col cols="12" md="5" lg="4" xl="3">
        <bottom-navigation>
          <bottom-navigation-item :to="{name: 'me'}" icon="i-person-gradient">
            {{ t('Me') }}
          </bottom-navigation-item>

          <bottom-navigation-item :to="{name: 'home'}" icon="i-location">
            {{ t('Collaborators') }}
          </bottom-navigation-item>

          <bottom-navigation-item :to="{name: 'consultations'}" icon="i-record">
            {{ t('Records') }}
          </bottom-navigation-item>

          <bottom-navigation-item :to="{name: 'wallet'}" icon="i-wallet">
            {{ t('Wallet') }}
          </bottom-navigation-item>

          <bottom-navigation-item :to="{name: 'menu'}" icon="i-menu">
            {{ t('Menu') }}
          </bottom-navigation-item>
        </bottom-navigation>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import BottomNavigation from "../../components/BottomNavigation/BottomNavigation";
import BottomNavigationItem from "../../components/BottomNavigation/BottomNavigationItem";
import ISos from "../../components/Icons/ISos";

export default {
  name: "MainLayout",
  components: {
    BottomNavigation,
    BottomNavigationItem,
    ISos
  }
}
</script>

<style scoped>
</style>
